import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getAttachmentDisplayLabel, type MessageAttachmentResponse } from '@/entities/conversations';
import { isImageAttachment } from '../model/attachments';
import { MessageFileAttachment } from './MessageFileAttachment';
import { MessageImageAttachment } from './MessageImageAttachment';

type Props = {
  /** Вложение сообщения */
  attachment: MessageAttachmentResponse;
};

/** Вложение сообщения: изображение — превью, прочий файл — именем. */
export const MessageAttachmentView: FC<Props> = ({ attachment }) => {
  const { t } = useTranslation(['dialogs']);
  const name = getAttachmentDisplayLabel(attachment) || t('dialogs:textFeed.attachment');

  return isImageAttachment(attachment) ? (
    <MessageImageAttachment attachment={attachment} name={name} />
  ) : (
    <MessageFileAttachment attachment={attachment} name={name} />
  );
};
